import { graphql } from 'react-apollo';
import compose from 'lodash/flowRight';
import gql from 'graphql-tag';

import { DILM_CLIENT_CONTEXT, LM_CLIENT_CONTEXT } from '../../constants';
import MARK_SCHEDULE_REQUEST_ATTEMPT_AS_SCHEDULED_MUTATION from './LegacyMarkScheduleRequestAttemptAsScheduledMutation.graphql';
import WIDGET_SESSION_SCHEDULED_MUTATION from './WidgetSessionScheduledMutation.graphql';

import AppointmentForm from './AppointmentForm';

export const CREATE_USER_MUTATION = gql`
  mutation createUser(
    $username: String!
    $password: String!
    $givenName: String!
    $familyName: String!
    $verificationToken: String
  ) {
    createUser(
      username: $username
      password: $password
      givenName: $givenName
      familyName: $familyName
      verificationToken: $verificationToken
    ) {
      user {
        id
        display
      }
      status
      message
      errors {
        key
        messages
      }
    }
  }
`;

export const CREATE_PATIENT_MUTATION = gql`
  mutation createPatient(
    $userId: ID!
    $givenName: String!
    $familyName: String!
    $birthDate: Date!
    $email: String!
    $mobilePhone: String!
    $termsAgreedAt: DateTime!
  ) {
    createPatient(
      userId: $userId
      givenName: $givenName
      familyName: $familyName
      birthDate: $birthDate
      email: $email
      mobilePhone: $mobilePhone
      termsAgreedAt: $termsAgreedAt
    ) {
      patient {
        id
        display
        birthDate
        email
        mobilePhone
      }
      status
      message
      errors {
        key
        messages
      }
    }
  }
`;

export const CREATE_FAVORITE_PROVIDER_MUTATION = gql`
  mutation createFavoriteProvider($patientId: ID!, $providerId: ID!) {
    createFavoriteProvider(patientId: $patientId, providerId: $providerId) {
      status
      message
      errors {
        key
        messages
      }
    }
  }
`;

export const CREATE_DEPENDENT_MUTATION = gql`
  mutation createDependent(
    $caregiverId: ID!
    $givenName: String!
    $familyName: String!
    $birthDate: Date!
  ) {
    createDependent(
      caregiverId: $caregiverId
      givenName: $givenName
      familyName: $familyName
      birthDate: $birthDate
    ) {
      patient {
        id
        display
        birthDate
      }
      status
      message
      errors {
        key
        messages
      }
    }
  }
`;

export const CREATE_APPOINTMENT_MUTATION = gql`
  mutation createAppointment(
    $openingId: ID!
    $provider: AppointmentEmbeddedObjectInput!
    $reasonForVisit: AppointmentEmbeddedObjectInput!
    $widgetId: ID
    $partnerId: ID
    $userId: ID
    $patientId: ID
    $patientName: String
    $patientGivenName: String
    $patientFamilyName: String
    $patientBirthDate: Date!
    $contactName: String
    $contactGivenName: String
    $contactFamilyName: String
    $contactEmail: String!
    $contactMobilePhone: String!
    $notes: String
    $verificationToken: String
    $termsAgreedAt: DateTime!
    $source: AppointmentSourceInput
    $patientCoverage: [PatientCoverageInput]
  ) {
    createAppointment(
      openingId: $openingId
      provider: $provider
      reasonForVisit: $reasonForVisit
      widgetId: $widgetId
      partnerId: $partnerId
      userId: $userId
      patientId: $patientId
      patientName: $patientName
      patientGivenName: $patientGivenName
      patientFamilyName: $patientFamilyName
      patientBirthDate: $patientBirthDate
      contactName: $contactName
      contactGivenName: $contactGivenName
      contactFamilyName: $contactFamilyName
      contactEmail: $contactEmail
      contactMobilePhone: $contactMobilePhone
      notes: $notes
      verificationToken: $verificationToken
      termsAgreedAt: $termsAgreedAt
      source: $source
      patientCoverage: $patientCoverage
    ) {
      appointment {
        id
        patientToken
        status
      }
      status
      message
      errors {
        key
        messages
        errors {
          key
          messages
        }
      }
    }
  }
`;

export default compose(
  graphql(CREATE_USER_MUTATION, {
    name: 'createUser',
    alias: 'withCreateUser',
    options: { context: LM_CLIENT_CONTEXT },
  }),
  graphql(CREATE_PATIENT_MUTATION, {
    name: 'createPatient',
    alias: 'withCreatePatient',
    options: { context: LM_CLIENT_CONTEXT },
  }),
  graphql(CREATE_FAVORITE_PROVIDER_MUTATION, {
    name: 'createFavoriteProvider',
    alias: 'withCreateFavoriteProvider',
    options: { context: LM_CLIENT_CONTEXT },
  }),
  graphql(CREATE_DEPENDENT_MUTATION, {
    name: 'createDependent',
    alias: 'withCreateDependent',
    options: { context: LM_CLIENT_CONTEXT },
  }),
  graphql(CREATE_APPOINTMENT_MUTATION, {
    name: 'createAppointment',
    alias: 'withCreateAppointment',
    options: { context: LM_CLIENT_CONTEXT },
  }),
  graphql(WIDGET_SESSION_SCHEDULED_MUTATION, {
    name: 'widgetSessionScheduled',
    alias: 'withWidgetSessionScheduled',
    options: { context: DILM_CLIENT_CONTEXT },
  }),
  graphql(MARK_SCHEDULE_REQUEST_ATTEMPT_AS_SCHEDULED_MUTATION, {
    name: 'markScheduleRequestAttemptAsScheduled',
    alias: 'withMarkScheduleRequestAttemptAsScheduled',
    options: { context: DILM_CLIENT_CONTEXT },
  })
)(AppointmentForm);
